import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import { countCurrentPage } from "@/api/dataTrans"
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
/* 把默认英文版改回中文  zh-CN , en(英文)*/
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n

import echarts from 'echarts'
import '@/styles/index.scss' // global css
import "@/styles/icon/iconfont.css"
import App from './App'
import store from './store'
// import router from './router'
import router from './router.js'
import '@/icons' // icon
import '@/permission' // permission control
import {
  message
} from '@/utils/resetMessage'
import VueCodemirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import VueResource from 'vue-resource'
import Distpicker from 'v-distpicker'
Vue.component('v-distpicker', Distpicker)
/**
 * If you don't want to use mock-server
 * you want to use mockjs for request interception
 * you can execute:
 *
 * import { mockXHR } from '../mock'
 * mockXHR()
 */

// set ElementUI lang to EN
import VueTaber from 'vue-tabs'
Vue.use(VueTaber)
Vue.use(ElementUI, {
  locale
})
Vue.prototype.$message = message
Vue.config.productionTip = false
Vue.prototype.$countCurrentPage = countCurrentPage
// eslint-disable-next-line no-undef
Vue.use(VueCodemirror)
Vue.use(VueResource)
// Vue.prototype.$router = router

new Vue({
  el: '#app',
  router,
  store,
  echarts,
  render: h => h(App)
})
